// Freight Forwarder API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type FreightForwarderRequests = {
    create: RequestConfigFunction,
    get: RequestConfigFunction<{id:number}>,
    update: RequestConfigFunction<{id:number}>,
    filterRequest: RequestConfigFunction<{ params?: any }>,
}

const freightForwarderRequests: FreightForwarderRequests = {
    create: () => {
        return {
            url: 'freightforwarder',
            method: 'POST',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `freightforwarder/${id}`,
            method: 'GET',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `freightforwarder/${id}`,
            method: 'PUT',
        }
    },
    filterRequest: ({
        params = {},
    }) => {
        return {
            url: 'freightforwarder/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
}

export default freightForwarderRequests
